import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { CodingFieldAdapter } from 'components/Assessments/PatAssessment/adapters/CodingFieldAdapter'
import { PatAssessmentQuestionnaireItem } from 'components/Assessments/PatAssessment/types/questionnaire'
import { PatFormData } from 'components/Assessments/PatAssessment/types/PatFormData'
import { NextStepsFormField } from './formField'

/**
 * Next Steps subsection adapter for PAT Assessment
 * Handles next steps extraction and transformation
 */
export class NextStepsAdapter extends CodingFieldAdapter {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<PatFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const finalNotes = this.extractNotesField(
      flatAnswersArray,
      PatAssessmentQuestionnaireItem.NEXT_STEPS_FINAL_NOTES
    )

    const qualificationStatus = this.extractSingleCodingValue(
      flatAnswersArray,
      PatAssessmentQuestionnaireItem.NEXT_STEPS_QUALIFICATION_STATUS,
      false
    )

    const requestedDocs = this.extractCodingArray(
      flatAnswersArray,
      PatAssessmentQuestionnaireItem.NEXT_STEPS_REQUESTED_DOCS,
      false
    )

    const specificNeedsForDocs = this.extractCodingArray(
      flatAnswersArray,
      PatAssessmentQuestionnaireItem.NEXT_STEPS_SPECIFIC_NEEDS_FOR_DOCS,
      false
    )

    const requestQa = this.extractSingleCodingValue(
      flatAnswersArray,
      PatAssessmentQuestionnaireItem.NEXT_STEPS_QA,
      false
    )

    return {
      [NextStepsFormField.FINAL_NOTES]: finalNotes,
      [NextStepsFormField.QUALIFICATION_STATUS]: qualificationStatus,
      [NextStepsFormField.REQUESTED_DOCS]: requestedDocs,
      [NextStepsFormField.SPECIFIC_NEEDS_FOR_DOCS]: specificNeedsForDocs,
      [NextStepsFormField.REQUEST_QA]: requestQa
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    const finalNotesMutation = this.buildNotesFieldMutation(
      NextStepsFormField.FINAL_NOTES,
      PatAssessmentQuestionnaireItem.NEXT_STEPS_FINAL_NOTES
    )
    if (finalNotesMutation) mutations.push(finalNotesMutation)

    const qualificationStatusMutation = this.buildSingleCodingValueMutation(
      NextStepsFormField.QUALIFICATION_STATUS,
      PatAssessmentQuestionnaireItem.NEXT_STEPS_QUALIFICATION_STATUS,
      false
    )
    if (qualificationStatusMutation) mutations.push(qualificationStatusMutation)

    const requestedDocsMutation = this.buildCodingArrayMutation(
      NextStepsFormField.REQUESTED_DOCS,
      PatAssessmentQuestionnaireItem.NEXT_STEPS_REQUESTED_DOCS,
      false
    )
    if (requestedDocsMutation) mutations.push(requestedDocsMutation)

    const specificNeedsForDocsMutation = this.buildCodingArrayMutation(
      NextStepsFormField.SPECIFIC_NEEDS_FOR_DOCS,
      PatAssessmentQuestionnaireItem.NEXT_STEPS_SPECIFIC_NEEDS_FOR_DOCS,
      false
    )
    if (specificNeedsForDocsMutation) mutations.push(specificNeedsForDocsMutation)

    const requestQaMutation = this.buildSingleCodingValueMutation(
      NextStepsFormField.REQUEST_QA,
      PatAssessmentQuestionnaireItem.NEXT_STEPS_QA,
      false
    )
    if (requestQaMutation) mutations.push(requestQaMutation)

    return mutations
  }
}
